import { render, staticRenderFns } from "./ForecastLeyend.vue?vue&type=template&id=53ff153a&scoped=true&"
import script from "./ForecastLeyend.vue?vue&type=script&lang=js&"
export * from "./ForecastLeyend.vue?vue&type=script&lang=js&"
import style0 from "./ForecastLeyend.vue?vue&type=style&index=0&id=53ff153a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff153a",
  null
  
)

export default component.exports